import { Icon } from "@iconify/react/dist/iconify.js";

const SearchBy = ({ value, onChange }) => {
    return (
        <>
            <form className="navbar-search">
                <input
                    type="text"
                    className="bg-base h-40-px w-auto"
                    name="search"
                    placeholder="Search"
                    value={value}
                    onChange={onChange}
                />
                <Icon icon="ion:search-outline" className="icon" />
            </form>
        </>
    );
}
export default SearchBy;